
import { Component, Prop, Vue } from "vue-property-decorator";
import { AdminBadgeColor } from "@/helpers/admin-badges";

// Пилюля с цветной обводкой для статусов, типов и провайдеров в таблицах админки
@Component
export default class AdminBadge extends Vue {
  @Prop({ default: "grey" }) color!: AdminBadgeColor;
  @Prop() icon: string | undefined;
  // Одинаковая ширина бейджей колонки — колонка не прыгает при прокрутке
  @Prop() minWidth: number | undefined;
}
